export const getTaskRawState = (task) => Number(task?.raw_state ?? task?.state ?? 0);

export const isTaskRawCompleted = (task) => {
  if (task?.raw_completed != null) return !!task.raw_completed;
  return !!task?.completed;
};

export const getTaskDisplayState = (task) =>
  Number(task?.ui_state ?? task?.display_state ?? getTaskRawState(task));

export const isTaskDisplayCompleted = (task) => {
  if (task?.ui_completed != null) return !!task.ui_completed;
  if (task?.display_completed != null) return !!task.display_completed;
  return isTaskRawCompleted(task);
};

export const isDeleted = (task) => getTaskRawState(task) === 5;

export const statusLabel = (task) => {
  if (isDeleted(task)) return "Eliminada";
  if (isTaskDisplayCompleted(task)) return "Completada";
  switch (getTaskDisplayState(task)) {
    case 1:
      return "Por hacer";
    case 2:
      return "En proceso";
    case 3:
      return "Completada";
    default:
      return "Por hacer";
  }
};

 